import React, { Component } from "react";
import MyShopCard from "./MyShopCard";

class MyShopGrid extends Component {
  constructor(props) {
    super(props);
  }

  getMobileDivs = data => {
    return data.map(rec => {
      //console.log(JSON.stringify(rec));
      return (
        <MyShopCard
          key={rec.key}
          tableName={this.props.tableName}
          handleDelete={this.props.handleDelete}
          ogTableDef={this.props.ogTableDef}
          genNotification={this.props.genNotification}
          cellPhone={this.props.refPhoneNumber}
          handleEdit={this.props.handleEdit}
          data={rec}
        />
      );
    });
  };

  render() {
    if (
      this.props.data &&
      this.props.data !== undefined &&
      this.props.data.length > 0
    ) {
      return <div>{this.getMobileDivs(this.props.data)}</div>;

      //return this.getRows(this.props.data);
    } else {
      return (
        <div
          style={{
            marginTop: "30px"
          }}
        >
          No Items listed in your shop
        </div>
      );
    }
  }
}

export default MyShopGrid;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/MyShopGrid.jsx